export const rooms = [
  "Room 1",
  "Room 2",
  "Room 3",
  "Room Mix 4-1",
  "Room Mix 4-2",
  "Room Mix 4-3",
  "Room 5 Bags",
  "Room 6 Pouch",
  "Bulk Zone",        
  "Manual Zone",
];
